import { render } from "./Drugs.vue?vue&type=template&id=f7503d00&scoped=true"
import script from "./Drugs.vue?vue&type=script&lang=js"
export * from "./Drugs.vue?vue&type=script&lang=js"

import "./Drugs.vue?vue&type=style&index=0&id=f7503d00&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7503d00"]])

export default __exports__